import { render, staticRenderFns } from "./supportDoc.vue?vue&type=template&id=4b76c78c&"
import script from "./supportDoc.vue?vue&type=script&lang=js&"
export * from "./supportDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports